import '../../styles/Profile.css'
import React, { useState, useEffect } from 'react';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Password } from 'primereact/password';
import { Toast } from 'primereact/toast';
import countryList from "react-select-country-list";
import Select from "react-select";
import { auth } from '../../config/firebase';
import ConnectionManager from "./connectionManager";
import { signOut as firebaseSignOut } from "firebase/auth";
import {useNavigate} from "react-router-dom";
import { City } from 'country-state-city';
import StripePricingTable from "./StripePricingTable";
import ProfileAvatar from "./ProfileAvatar";
import axios from 'axios';
import Avatar1 from "../../assets/avatars/Boy_1.svg";
import Avatar2 from "../../assets/avatars/Boy_2.svg";
import Avatar3 from "../../assets/avatars/Boy_3.svg";
import Avatar4 from "../../assets/avatars/Boy_4.svg";
import Avatar5 from "../../assets/avatars/Boy_5.svg";
import Avatar6 from "../../assets/avatars/Boy_6.svg";
import Avatar7 from "../../assets/avatars/Girl_1.svg";
import Avatar8 from "../../assets/avatars/Girl_2.svg";
import Avatar9 from "../../assets/avatars/Girl_3.svg";
import Avatar10 from "../../assets/avatars/Girl_4.svg";
import Avatar11 from "../../assets/avatars/Girl_5.svg";
import Avatar12 from "../../assets/avatars/Girl_6.svg";

const Profil = () => {
    const [activeTab, setActiveTab] = useState('personal');
    const [countrySelect, setCountrySelect] = useState(null);
    const [cities, setCities] = useState([]);
    const [citySelect, setCitySelect] = useState(null);
    const countryOptions = countryList().getData();
    const [error, setError] = useState("");
    const [showAvatarModal, setShowAvatarModal] = useState(false);
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState({
        name: '',
        email: '',
        age: '',
        birthday: '',
        country: '',
        bio: '',
        loginMethod: '',
        photoURL: '',
        subscriptionTier: 'free',
        // platform settings
        dashboardWallpaper: ''
    });
    const [originalWallpaper, setOriginalWallpaper] = useState('');
    const [platformChanged, setPlatformChanged] = useState(false);
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(true);
    const [formChanged, setFormChanged] = useState(false);
    const toast = React.useRef(null);

    // Dynamically load wallpapers from animation folder (Webpack/CRA)
    const wallpapers = React.useMemo(() => {
        try {
            const gifReq = require.context('../../assets/animation', false, /\.gif$/);
            
            return gifReq.keys().map((key) => ({
                name: key.replace('./', ''),
                src: gifReq(key)
            }));
        } catch (e) {
            return [];
        }
    }, []);

    const handleCountryChange = (selectedOption) => {
        setCountrySelect(selectedOption);
        setCitySelect(null);
        setUserInfo(prev => ({
            ...prev,
            country: selectedOption ? selectedOption.label : '',
            countryCode: selectedOption ? selectedOption.value : '',
            city: null
        }));
        setFormChanged(true);
        if (selectedOption?.value) {
            const citiesData = City.getCitiesOfCountry(selectedOption.value);
            const cityOptions = citiesData?.map(city => ({
                label: city.name,
                value: city.name
            })) || [];
            setCities(cityOptions);
        } else {
            setCities([]);
        }
    };

    const avatars = [
        { id: "avatar1", src: Avatar1 },
        { id: "avatar2", src: Avatar2 },
        { id: "avatar3", src: Avatar3 },
        { id: "avatar4", src: Avatar4 },
        { id: "avatar5", src: Avatar5 },
        { id: "avatar6", src: Avatar6 },
        { id: "avatar7", src: Avatar7 },
        { id: "avatar8", src: Avatar8 },
        { id: "avatar9", src: Avatar9 },
        { id: "avatar10", src: Avatar10 },
        { id: "avatar11", src: Avatar11 },
        { id: "avatar12", src: Avatar12 },
    ];

    useEffect(() => {
        if (countrySelect?.value) {
            const citiesData = City.getCitiesOfCountry(countrySelect.value);
            const cityOptions = citiesData?.map(city => ({
                label: city.name,
                value: city.name
            })) || [];
            setCities(cityOptions);
        } else {
            setCities([]);
        }
    }, [countrySelect]);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                if (!auth.currentUser) {
                    setLoading(false);
                    return;
                }
                const response = await axios.get(`https://api.frazza.online/user/${auth.currentUser.uid}`);
                if (response.data.success) {
                    const userData = response.data.data;
                    const photoURL = userData.loginMethod === 'google' && auth.currentUser.photoURL;
                    const wallpaper = userData.dashboardWallpaper || localStorage.getItem('dashboardWallpaper') || '';
                    setUserInfo({
                        ...userData,
                        photoURL,
                        dashboardWallpaper: wallpaper
                    });
                    setOriginalWallpaper(wallpaper);
                    if (userData.country) {
                        const countryOption = countryOptions.find(option =>
                            option.label === userData.country);
                        setCountrySelect(countryOption || null);
                        if (userData.city && countryOption) {
                            const citiesData = City.getCitiesOfCountry(countryOption.value);
                            const cityOptions = citiesData?.map(city => ({
                                label: city.name,
                                value: city.name
                            })) || [];
                            const cityOption = cityOptions.find(option => option.value === userData.city);
                            setCitySelect(cityOption || null);
                        }
                    }
                }
                setLoading(false);
            } catch (error) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: `Failed to load profile: ${error.response?.data?.error || error.message}`,
                    life: 5000
                });
                setLoading(false);
            }
        };
        fetchUserData();
    }, [countryOptions]);

    const signOut = async () => {
        try {
            await firebaseSignOut(auth);
            navigate("/");
        } catch (error) {
            setError("An error occurred. Please try again.");
        }
    };

    const handleCityChange = (selectedOption) => {
        setCitySelect(selectedOption);
        setUserInfo(prev => ({
            ...prev,
            city: selectedOption ? selectedOption.value : ''
        }));
        setFormChanged(true);
    };

    const calculateAgeFromBirthday = (birthdayString) => {
        if (!birthdayString) return '';
        const birthdayDate = new Date(birthdayString);
        if (isNaN(birthdayDate.getTime())) return '';
        const today = new Date();
        let age = today.getFullYear() - birthdayDate.getFullYear();
        const monthDiff = today.getMonth() - birthdayDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdayDate.getDate())) {
            age--;
        }
        return age.toString();
    };

    const updateBirthdayFromAge = (currentBirthday, age) => {
        if (!age || isNaN(parseInt(age))) return currentBirthday;
        const ageNum = parseInt(age);
        if (ageNum < 0 || ageNum > 120) return currentBirthday;
        const today = new Date();
        if (!currentBirthday) {
            const birthYear = today.getFullYear() - ageNum;
            return `${today.getMonth() + 1}/${today.getDate()}/${birthYear}`;
        }
        const birthdayDate = new Date(currentBirthday);
        if (isNaN(birthdayDate.getTime())) {
            const birthYear = today.getFullYear() - ageNum;
            return `${today.getMonth() + 1}/${today.getDate()}/${birthYear}`;
        }
        const birthYear = today.getFullYear() - ageNum;
        birthdayDate.setFullYear(birthYear);
        return `${birthdayDate.getMonth() + 1}/${birthdayDate.getDate()}/${birthdayDate.getFullYear()}`;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const updatedUserInfo = { ...userInfo };
        updatedUserInfo[name] = value;
        if (name === 'age' && value) {
            updatedUserInfo.birthday = updateBirthdayFromAge(userInfo.birthday, value);
        }
        if (name === 'birthday' && value) {
            updatedUserInfo.age = calculateAgeFromBirthday(value);
        }
        setUserInfo(updatedUserInfo);
        setFormChanged(true);
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handlePlatformSave = async () => {
        try {
            if (!auth.currentUser) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Authentication Error',
                    detail: 'You must be logged in to update platform settings',
                    life: 5000
                });
                return;
            }
            const updateData = {
                dashboardWallpaper: userInfo.dashboardWallpaper || ''
            };
            // Persist to backend if possible
            const response = await axios.put(`https://api.frazza.online/user/${auth.currentUser.uid}`, updateData);
            if (!response.data.success) {
                throw new Error(response.data.error || 'Failed to update platform settings');
            }
            // Always store locally so Dashboard can read it immediately
            if (userInfo.dashboardWallpaper) {
                localStorage.setItem('dashboardWallpaper', userInfo.dashboardWallpaper);
            } else {
                localStorage.removeItem('dashboardWallpaper');
            }
            // Update the original wallpaper so Reset button works correctly
            setOriginalWallpaper(userInfo.dashboardWallpaper);
            setPlatformChanged(false);
            // Notify others within the app (same tab)
            console.log('Dispatching wallpaper update event:', userInfo.dashboardWallpaper);
            window.dispatchEvent(new CustomEvent('frazza:wallpaperUpdated', {
                detail: { name: userInfo.dashboardWallpaper || '' }
            }));
            toast.current.show({
                severity: 'success',
                summary: 'Saved',
                detail: 'Platform settings updated',
                life: 3000
            });
        } catch (error) {
            // Even if backend fails, store locally as a fallback
            if (userInfo.dashboardWallpaper) {
                localStorage.setItem('dashboardWallpaper', userInfo.dashboardWallpaper);
            } else {
                localStorage.removeItem('dashboardWallpaper');
            }
            window.dispatchEvent(new CustomEvent('frazza:wallpaperUpdated', {
                detail: { name: userInfo.dashboardWallpaper || '' }
            }));
            toast.current.show({
                severity: 'warn',
                summary: 'Saved Locally',
                detail: error.response?.data?.error || error.message || 'Could not sync with server, saved locally',
                life: 4000
            });
        }
    };

    const handleProfileSubmit = async (e) => {
        e.preventDefault();
        try {
            if (!auth.currentUser) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Authentication Error',
                    detail: 'You must be logged in to update your profile',
                    life: 5000
                });
                return;
            }
            const updateData = {
                userName: userInfo.userName || '',
                bio: userInfo.bio || '',
                country: userInfo.country || '',
                countryCode: userInfo.countryCode || '',
                city: userInfo.city || '',
                age: userInfo.age ? String(userInfo.age) : '',
                birthday: userInfo.birthday || ''
            };
            const response = await axios.put(`https://api.frazza.online/user/${auth.currentUser.uid}`, updateData);
            if (response.data.success) {
                setFormChanged(false);
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Profile updated successfully',
                    life: 3000
                });
            } else {
                throw new Error(response.data.error || 'Failed to update profile');
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: `Failed to update profile: ${error.response?.data?.error || error.message}`,
                life: 5000
            });
        }
    };

    const handleSecuritySubmit = async (e) => {
        e.preventDefault();
        if (passwordData.newPassword !== passwordData.confirmPassword) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Passwords do not match',
                life: 4000
            });
            return;
        }
        try {
            const user = auth.currentUser;
            if (!user) {
                throw new Error("No authenticated user found");
            }
            if (!passwordData.currentPassword) {
                throw new Error("Current password is required");
            }
            const credential = EmailAuthProvider.credential(
                user.email,
                passwordData.currentPassword
            );
            try {
                await reauthenticateWithCredential(user, credential);
            } catch (authError) {
                if (authError.code === 'auth/invalid-credential') {
                    throw new Error("The current password you entered is incorrect");
                } else {
                    throw authError;
                }
            }
            await updatePassword(user, passwordData.newPassword);
            const response = await axios.post(`https://api.frazza.online/user/${user.uid}/password`, {
                passwordLastUpdated: new Date().toISOString()
            });
            if (!response.data.success) {
                throw new Error(response.data.error || 'Failed to update password timestamp');
            }
            setPasswordData({
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            });
            toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Password updated successfully',
                life: 3000
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.response?.data?.error || error.message || 'Failed to update password',
                life: 5000
            });
        }
    };

    if (loading) {
        return <div className="profile-loading">Loading user information...</div>;
    }

    return (
        <div className="settings-container">
            <Toast ref={toast} position="top-right" />
            <div className="settings-sidebar">
                <div className="sidebar-profile">
                    <div
                        className="avatar-wrapper clickable-avatar"
                        onClick={() => setShowAvatarModal(true)}
                        title="Change avatar"
                    >
                        <img
                            src={avatars.find(a => a.id === userInfo.avatar)?.src || userInfo.photoURL}
                            alt="Avatar"
                            className="user-avatar"
                        />
                        <div className="avatar-edit-badge">
                            <i className="pi pi-pencil"></i>
                        </div>
                    </div>
                    <h3 className="user-name">{userInfo.name || "Name"} {userInfo.lastName || ""}</h3>
                    <p className="user-email">{userInfo.userName || "Username"}</p>
                </div>
                <nav className="settings-nav">
                    <Button
                        className={`nav-item ${activeTab === 'personal' ? 'active' : ''}`}
                        onClick={() => setActiveTab('personal')}
                        icon="pi pi-user"
                        label="Personal Info"
                    />
                    <Button
                        className={`nav-item ${activeTab === 'login' ? 'active' : ''}`}
                        onClick={() => setActiveTab('login')}
                        icon="pi pi-shield"
                        label="Security"
                    />
                    <Button
                        className={`nav-item ${activeTab === 'platform' ? 'active' : ''}`}
                        onClick={() => setActiveTab('platform')}
                        icon="pi pi-palette"
                        label="Appearance"
                    />
                    <Button
                        className={`nav-item ${activeTab === 'subscriptions' ? 'active' : ''}`}
                        onClick={() => setActiveTab('subscriptions')}
                        icon="pi pi-credit-card"
                        label="Subscription"
                    />
                    <Button
                        className={`nav-item ${activeTab === 'connectManager' ? 'active' : ''}`}
                        onClick={() => setActiveTab('connectManager')}
                        icon="pi pi-heart"
                        label="Partner"
                    />
                </nav>
                <div className="sidebar-footer">
                    <Button
                        className="logout-button"
                        icon="pi pi-sign-out"
                        label="Log Out"
                        severity="help"
                        outlined
                        raised
                        onClick={signOut}
                    />
                </div>
            </div>
            <div className="settings-content">
                {activeTab === 'personal' && (
                    <div className="settings-panel">
                        <div className="panel-header">
                            <h2>Personal Information</h2>
                            <p>Manage your personal details and how others see you</p>
                        </div>
                        <form onSubmit={handleProfileSubmit} className="settings-form-modern frazza-form">
                            <div className="settings-card">
                                <div className="card-section">
                                    <h3 className="section-title">Profile Details</h3>
                                    <div className="frazza-form-row two-col">
                                        <div className="frazza-form-group">
                                            <label htmlFor="userName" className="frazza-form-label">Username</label>
                                            <InputText id="userName" name="userName" value={userInfo.userName} onChange={handleInputChange} placeholder="Enter username" className="frazza-input" />
                                        </div>
                                        <div className="frazza-form-group">
                                            <label htmlFor="email" className="frazza-form-label">Email Address</label>
                                            <InputText id="email" name="email" value={userInfo.email} disabled className="frazza-input" />
                                            <span className="frazza-form-help">Email cannot be changed</span>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card-divider"></div>
                                
                                <div className="card-section">
                                    <h3 className="section-title">Location</h3>
                                    <div className="frazza-form-row two-col">
                                        <div className="frazza-form-group">
                                            <label htmlFor="country" className="frazza-form-label">Country</label>
                                            <Select
                                                options={countryOptions}
                                                value={countrySelect}
                                                onChange={handleCountryChange}
                                                className="modern-select"
                                                classNamePrefix="select"
                                                id="country"
                                                placeholder="Select country"
                                            />
                                        </div>
                                        <div className="form-field">
                                            <label htmlFor="city">City</label>
                                            <Select
                                                options={cities}
                                                value={citySelect}
                                                onChange={handleCityChange}
                                                className="modern-select"
                                                classNamePrefix="select"
                                                id="city"
                                                isDisabled={!countrySelect}
                                                placeholder={countrySelect ? "Select city" : "Select country first"}
                                            />
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="card-divider"></div>
                                
                                <div className="card-section">
                                    <h3 className="section-title">Birthday</h3>
                                    <div className="frazza-form-row">
                                        <div className="frazza-form-group">
                                            <label htmlFor="birthday" className="frazza-form-label">Date of Birth</label>
                                            <InputText id="birthday" name="birthday" value={userInfo.birthday} onChange={handleInputChange} placeholder="MM/DD/YYYY" className="frazza-input" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="frazza-form-actions">
                                <Button type="button" label="Cancel" className="frazza-btn frazza-btn-secondary" onClick={() => setFormChanged(false)} disabled={!formChanged} />
                                <Button type="submit" label="Save Changes" className="frazza-btn frazza-btn-primary" disabled={!formChanged} />
                            </div>
                        </form>
                    </div>
                )}
                
                {activeTab === 'login' && (
                    <div className="settings-panel">
                        <div className="panel-header">
                            <h2>Security</h2>
                            <p>Manage your password and account security settings</p>
                        </div>
                        <div className="settings-form-modern">
                            <div className="settings-card">
                                <div className="card-section">
                                    <h3 className="section-title">Password</h3>
                                    {userInfo.loginMethod === 'google' ? (
                                        <div className="info-message">
                                            <i className="pi pi-google"></i>
                                            <div>
                                                <strong>Signed in with Google</strong>
                                                <p>Your password is managed through your Google account.</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <form onSubmit={handleSecuritySubmit} className="frazza-form">
                                            <div className="frazza-form-group">
                                                <label htmlFor="currentPassword" className="frazza-form-label required">Current Password</label>
                                                <Password id="currentPassword" name="currentPassword"
                                                          value={passwordData.currentPassword}
                                                          onChange={handlePasswordChange}
                                                          feedback={false}
                                                          toggleMask
                                                          className="frazza-input"
                                                          placeholder="Enter current password"
                                                />
                                            </div>
                                            <div className="frazza-form-row two-col">
                                                <div className="frazza-form-group">
                                                    <label htmlFor="newPassword" className="frazza-form-label required">New Password</label>
                                                    <Password id="newPassword" name="newPassword"
                                                              value={passwordData.newPassword}
                                                              onChange={handlePasswordChange}
                                                              toggleMask
                                                              className="frazza-input"
                                                              placeholder="Create new password"
                                                    />
                                                    <span className="frazza-form-help">Use at least 8 characters with letters and numbers</span>
                                                </div>
                                                <div className="frazza-form-group">
                                                    <label htmlFor="confirmPassword" className="frazza-form-label required">Confirm New Password</label>
                                                    <Password id="confirmPassword" name="confirmPassword"
                                                              value={passwordData.confirmPassword}
                                                              onChange={handlePasswordChange}
                                                              feedback={false}
                                                              toggleMask
                                                              className="frazza-input"
                                                              placeholder="Re-enter new password"
                                                    />
                                                </div>
                                            </div>
                                            <div className="frazza-form-actions">
                                                <Button type="submit" label="Update Password" className="frazza-btn frazza-btn-primary" />
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                
                {activeTab === 'platform' && (
                    <div className="settings-panel">
                        <div className="panel-header">
                            <h2>Appearance</h2>
                            <p>Customize how Frazza looks and feels</p>
                        </div>
                        <div className="settings-form-modern">
                            <div className="settings-card">
                                <div className="card-section">
                                    <h3 className="section-title">Dashboard Wallpaper</h3>
                                    <p className="section-description">Choose a background for your dashboard</p>
                                    {wallpapers.length === 0 ? (
                                        <div className="info-message">
                                            <i className="pi pi-image"></i>
                                            <p>No wallpapers available</p>
                                        </div>
                                    ) : (
                                        <div className="wallpaper-grid-modern">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setUserInfo((prev) => ({ ...prev, dashboardWallpaper: '' }));
                                                    setPlatformChanged(true);
                                                }}
                                                className={`wallpaper-option ${!userInfo.dashboardWallpaper ? 'selected' : ''}`}
                                            >
                                                <div className="wallpaper-preview default">
                                                    <i className="pi pi-ban"></i>
                                                </div>
                                                <span className="wallpaper-label">None</span>
                                            </button>
                                            {wallpapers.map((w) => {
                                                const selected = userInfo.dashboardWallpaper === w.name;
                                                return (
                                                    <button
                                                        key={w.name}
                                                        type="button"
                                                        onClick={() => {
                                                            setUserInfo((prev) => ({ ...prev, dashboardWallpaper: w.name }));
                                                            setPlatformChanged(true);
                                                        }}
                                                        className={`wallpaper-option ${selected ? 'selected' : ''}`}
                                                    >
                                                        <div className="wallpaper-preview">
                                                            <img src={w.src} alt={w.name} />
                                                        </div>
                                                        <span className="wallpaper-label" title={w.name}>{w.name.replace('.gif', '')}</span>
                                                    </button>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className="form-actions">
                                <Button
                                    type="button"
                                    label="Reset"
                                    className="btn-secondary"
                                    onClick={() => {
                                        setUserInfo((prev) => ({ ...prev, dashboardWallpaper: originalWallpaper }));
                                        setPlatformChanged(false);
                                    }}
                                    disabled={!platformChanged}
                                />
                                <Button
                                    type="button"
                                    label="Save Changes"
                                    className="btn-primary"
                                    onClick={handlePlatformSave}
                                    disabled={!platformChanged}
                                />
                            </div>
                        </div>
                    </div>
                )}
                
                {activeTab === 'subscriptions' && (
                    <div className="settings-panel">
                        <div className="panel-header">
                            <h2>Subscription</h2>
                            <p>Manage your plan and billing</p>
                        </div>
                        <div className="subscription-content">
                            <StripePricingTable userId={auth.currentUser?.uid} />
                        </div>
                    </div>
                )}
                
                {activeTab === 'connectManager' && (
                    <div className="settings-panel">
                        <div className="panel-header">
                            <h2>Partner Connection</h2>
                            <p>Link with your partner to share experiences</p>
                        </div>
                        <ConnectionManager />
                    </div>
                )}
                
                <div className="mobile-logout">
                    <Button
                        className="logout-button"
                        icon="pi pi-sign-out"
                        label="Log Out"
                        severity="help"
                        outlined
                        raised
                        onClick={signOut}
                    />
                </div>
            </div>
            {showAvatarModal && (
                <div className="avatar-modal-overlay">
                    <div className="avatar-modal">
                        <button className="close-modal" onClick={() => setShowAvatarModal(false)}>
                            <i className="pi pi-times"></i>
                        </button>
                        <ProfileAvatar 
                            initialAvatar={userInfo.avatar}
                            onSelect={(avatarId) => {
                                setUserInfo(prev => ({ ...prev, avatar: avatarId }));
                                setShowAvatarModal(false);
                            }} 
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Profil;